<template>
  <v-container fluid class="pa-4 pa-sm-6">
    <!-- Header -->
    <v-row class="mb-5">
      <v-col cols="12">
        <div class="d-flex flex-wrap align-center justify-space-between">
          <div class="d-flex align-center">
            <v-avatar color="primary lighten-5" size="44" class="me-3">
              <v-icon color="primary" size="24">mdi-message-draw</v-icon>
            </v-avatar>
            <div>
              <h1 class="text-h5 font-weight-bold text--primary mb-0">Communications</h1>
              <p class="text-caption grey--text mb-0 mt-1">Manage contact messages and marketing resources</p>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Tabs -->
    <v-row>
      <v-col cols="12">
        <v-card class="main-card" elevation="1" outlined>
          <!-- Segmented Control -->
          <div class="tabs-wrapper px-4 pt-4 pb-0">
            <div class="segmented-control">
              <button
                :class="['segment-btn', { active: activeTab === 0 }]"
                @click="activeTab = 0"
              >
                <v-icon size="18" class="me-2">mdi-email-outline</v-icon>
                <span class="d-none d-sm-inline">Contact Us Messages</span>
                <span class="d-sm-none">Messages</span>
              </button>
              <button
                :class="['segment-btn', { active: activeTab === 1 }]"
                @click="activeTab = 1"
              >
                <v-icon size="18" class="me-2">mdi-folder-image</v-icon>
                <span class="d-none d-sm-inline">Marketing Resources</span>
                <span class="d-sm-none">Resources</span>
              </button>
            </div>
          </div>

          <!-- Content -->
          <div class="tab-content-wrapper pa-4">
            <v-fade-transition mode="out-in">
              <div v-if="activeTab === 0" key="contact">
                <contact-us-datatable></contact-us-datatable>
              </div>
              <div v-else key="marketing">
                <marketing-resources></marketing-resources>
              </div>
            </v-fade-transition>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContactUsDatatable from './ContactUsDatatable.vue'
import MarketingResources from './MarketingResources.vue'

export default {
  name: 'CommunicationsManager',
  components: {
    ContactUsDatatable,
    MarketingResources,
  },
  data() {
    return {
      activeTab: 0,
    }
  },
  watch: {
    $route() {
      document.title = 'PettyCash: Manager - Contact Us'
    },
  },
}
</script>

<style scoped>
.main-card {
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.tabs-wrapper {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

/* Segmented Control */
.segmented-control {
  display: inline-flex;
  background: #f0f2f5;
  border-radius: 12px;
  padding: 4px;
  gap: 4px;
  width: 100%;
  max-width: 520px;
}

.segment-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: #666;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}

.segment-btn:hover {
  color: #333;
  background: rgba(0, 0, 0, 0.03);
}

.segment-btn.active {
  background: var(--v-primary-base, #1976d2);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.25);
  font-weight: 700;
}

.segment-btn.active:hover {
  background: var(--v-primary-base, #1976d2);
}

/* Content area */
.tab-content-wrapper {
  background: #ffffff;
  min-height: 400px;
}

/* Fade transition */
.v-fade-transition-enter-active,
.v-fade-transition-leave-active {
  transition: opacity 0.2s ease;
}

.v-fade-transition-enter,
.v-fade-transition-leave-to {
  opacity: 0;
}

@media (max-width: 600px) {
  .segment-btn {
    padding: 10px 8px;
    font-size: 0.8rem;
  }
  .segmented-control {
    max-width: 100%;
  }
}
</style>
